import type { ReactElement } from 'react';
import { useState } from 'react';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';

function DeliveryInstructionsTooltip(): ReactElement {
  const [show, setShow] = useState(false);

  const showTooltip = () => {
    setShow(true);
  };
  const hideTooltip = () => {
    setShow(false);
  };

  return (
    <OverlayTrigger
      placement="top"
      show={show}
      overlay={(
        <Tooltip
          id="delivery-instructions-tooltip"
          onMouseEnter={showTooltip}
          onMouseLeave={hideTooltip}
        >
          60 Characters Max.
          {' '}
          <br />
          {' '}
          Special characters are not valid.
        </Tooltip>
      )}
    >
      <span
        onMouseEnter={showTooltip}
        onMouseLeave={hideTooltip}
      >
        ⓘ
      </span>
    </OverlayTrigger>
  );
}

export default DeliveryInstructionsTooltip;
